import { useManagePendingInvites } from "utilities/hooks/domain/team-onboarding/use-manage-pending-invites";
import ManageTeamInviteField from "./manage-team-invite-field";
import ManageTeamMembersList from "./manage-team-members-list";
import GroupMemberRecord from "models/view-models/group-member-record";
import { useState } from "react";
import React from "react";
import usePopulateWithExistingTeamMembers from "utilities/hooks/domain/team-onboarding/use-populate-with-existing-team-members";
import { TEAM_OWNER_COUNT } from "./manage-team-settings";

const CLASS_NAME = "c-manage-team-settings";

interface ManageTeamMembersProps {
    totalLicenses: number;
    teamMembersToMigrate: GroupMemberRecord[];
    emailsToInvite: string[];
    onUpdateTeamMembersToMigrate: (
        updatedTeamMembersList: GroupMemberRecord[]
    ) => void;
    onUpdateEmailsToInvite: (updatedEmailsList: string[]) => void;
}

const ManageTeamMembers = ({
    totalLicenses,
    teamMembersToMigrate,
    emailsToInvite,
    onUpdateTeamMembersToMigrate,
    onUpdateEmailsToInvite,
}: ManageTeamMembersProps) => {
    const [emailError, setEmailError] = useState<string | undefined>(undefined);

    const totalSeatsCurrentlyTaken =
        TEAM_OWNER_COUNT + teamMembersToMigrate.length + emailsToInvite.length;

    const totalSeatsRemaining = totalLicenses - totalSeatsCurrentlyTaken;

    const { handleAddClick, handleOnChange, inviteEmail } =
        useManagePendingInvites({
            totalLicenses: totalLicenses,
            teamMembersToMigrate: teamMembersToMigrate,
            emailsToInvite: emailsToInvite,
            onUpdateEmailsToInvite: onUpdateEmailsToInvite,
            onEmailError: (error) => {
                setEmailError(error);
            },
            totalSeatsCurrentlyTaken: totalSeatsCurrentlyTaken,
        });

    const { areGroupMembersLoading, teamOwner } =
        usePopulateWithExistingTeamMembers({
            onUpdateTeamMembersToMigrate,
        });

    return (
        <>
            <div className={`${CLASS_NAME}__card`}>
                <ManageTeamInviteField
                    emailError={emailError}
                    handleOnChange={handleOnChange}
                    inviteEmail={inviteEmail}
                    handleAddClick={handleAddClick}
                    totalSeatsRemaining={totalSeatsRemaining}
                />
                <ManageTeamMembersList
                    teamOwner={teamOwner}
                    teamMembersToMigrate={teamMembersToMigrate}
                    emailsToInvite={emailsToInvite}
                    onUpdateTeamMembersToMigrate={onUpdateTeamMembersToMigrate}
                    onUpdateEmailsToInvite={onUpdateEmailsToInvite}
                    areGroupMembersLoading={areGroupMembersLoading}
                    totalSeatsCurrentlyTaken={totalSeatsCurrentlyTaken}
                    totalSeatsRemaining={totalSeatsRemaining}
                />
            </div>
        </>
    );
};

export default ManageTeamMembers;
